import { render, staticRenderFns } from "./loginFooter.vue?vue&type=template&id=1c9171fc&scoped=true&"
import script from "./loginFooter.vue?vue&type=script&lang=js&"
export * from "./loginFooter.vue?vue&type=script&lang=js&"
import style0 from "./loginFooter.vue?vue&type=style&index=0&id=1c9171fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9171fc",
  null
  
)

export default component.exports